export default {
    NO_DATA_TO_DISPLAY: "Нет данных для отображения",
    SEARCH: "Поиск"
};
